window.handleForm = function (e, elem = null, reload = false, errorCallback = null) {
    window.stateIndicators?.saving();
    let form = elem?.closest('form') ?? this.closest('form');
    let xhr = new XMLHttpRequest();
    xhr.open(form.method, form.action);
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.setRequestHeader('X-CSRF-TOKEN', document.querySelector('meta[name="csrf-token"]').content);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.send($(form).getFormDataAssociative());
    xhr.onreadystatechange = function () {
        if (xhr.readyState !== XMLHttpRequest.DONE) {
            return;
        }

        if (xhr.status === 200) {
            window.stateIndicators?.saved();
            if (reload) {
                window.location.reload();
            }
            return;
        }
        // get response
        let response = JSON.parse(xhr.response);
        window.stateIndicators?.error(
            response.errors !== undefined
                ? response.errors[Object.keys(response.errors)[0]]
                : null
        );

        if (errorCallback !== undefined) {
            errorCallback(response);
        }
    };
}
